export default class gnavi {
    constructor(){

        this.$header;
        this.$container;
        this.$trigger;
        this.$link;
        this.$socialBtn;

        this.$subTrigger;
        this.$subContent;

        this.status = {
            mode : Useragnt.mobile?"close":"open",
            displayType : window.innerWidth > 750 ? "pc" : "sp",
            hoverTime : ''
        }

    }
    init(pageID){

        this.$header = document.getElementById("l-header");
        this.$container = document.getElementById("l-header__navi");
        this.$trigger = document.getElementById("l-header-btn");
        this.$socialBtn = document.getElementById("l-header__social");

        this.$subTrigger = document.querySelectorAll(".js__sub-navi-trigger");
        this.$subContent = document.querySelectorAll(".js__sub-navi-content");

        if(pageID === 'lineup'){
            this.$container.classList.add('is-white');
            if(this.$trigger) this.$trigger.classList.add('is-white');
        }

        if(this.status.displayType=="sp"){
            this.spMot("set");
        }


        if(this.status.displayType=="pc"){

            this.$link = this.$container.querySelectorAll("#l-header__navi__list a");

            // if(document.body.classList.contains("dog")){
            //     this.linkMot(this.$link[0],"show");
            // }else if(document.body.classList.contains("cat")){
            //         this.linkMot(this.$link[1],"show");
            // }else{
            //
            // }
            for(let i in this.$link){

                if(this.$link[i].nodeType!=1) break;

                this.$link[i].addEventListener("mouseenter",(e)=>{

                    this.linkMot(e.target,"show");
                });

                this.$link[i].addEventListener("mouseleave",(e)=>{
                    this.linkMot(e.target,"out");
                });
            }

            for(let i in this.$subTrigger){

                if(this.$subTrigger[i].nodeType!=1) break;

                this.$subTrigger[i].addEventListener("mouseenter",(e)=>{
                    if(this.$subTrigger[i].classList.contains('mouseenter')){
                        this.subOpen(i, 'show');
                    }
                });
                this.$subTrigger[i].addEventListener("mouseleave",(e)=>{
                    if(this.$subTrigger[i].classList.contains('mouseenter')) {
                        this.subOpen(i, 'hide');
                    }
                });
                this.$subContent[i].addEventListener("mouseenter",(e)=>{
                    clearTimeout(this.status.hoverTime);
                });
                this.$subContent[i].addEventListener("mouseleave",(e)=>{
                    if(this.$subTrigger[i].classList.contains('mouseenter')) {
                        this.subOpen(i, 'hide');
                    }
                });

            }

        }

        if(this.$trigger){
            this.$trigger.addEventListener("click",()=>{

                TweenMax.set(this.$socialBtn, {x: 0}); // PCのときの .dir-x のxをリセットする

                if(this.status.mode == "close"){

                    this.spMot("open");
                    document.getElementsByTagName("html")[0].classList.add('is-gnavi-open');

                }else{

                    this.spMot("close");
                    document.getElementsByTagName("html")[0].classList.remove('is-gnavi-open');

                }

            });
        }

        for(let i in this.$subTrigger) {

            if(this.$subTrigger[i].nodeType!=1) break;

            this.$subTrigger[i].addEventListener("click", (e) => {
                if(this.$subTrigger[i].classList.contains('is-open')) {
                    this.subOpen(i,'hide');
                }else{
                    this.subOpen(i,'show');
                }
            });
        }

        TweenMax.set(this.$header, {
            opacity: 1,
        });

    }
    //SP画面用のグロナビアクション
    spMot(type){

        if(type=="open"){

            this.status.mode = "open";
            this.$container.classList.add("is-open");
            this.spBtnMot();
            TweenMax.to(this.$container,0.6,{
                y : 0 + "%",
                onComplete:()=>{
                    TweenMax.staggerTo(this.$container.querySelectorAll(".js__gnavi-show"),0.6,{
                        y : 0,
                        opacity:1
                    },0.1);
                }
            })

        }else if(type=="close"){
            this.status.mode = "close";
            this.$container.classList.remove("is-open");
            this.spBtnMot();
            TweenMax.staggerTo(this.$container.querySelectorAll(".js__gnavi-show"),0.6,{
                y : 30,
                opacity:0
            },0.1);
            TweenMax.to(this.$container,0.6,{
                y : 110 + "%",
                delay : 0.8,
                onComplete:()=>{
                }
            })
        }else if(type=="reset"){
            this.status.mode = "open";
            this.$container.classList.add("is-open");
            TweenMax.set(this.$container,{
                y : 0 + "%"
            })
            TweenMax.set(this.$container.querySelectorAll(".js__gnavi-show"),{
                y : 0,
                opacity:1
            });
        }else{

            this.status.mode = "close";
            this.$container.classList.remove("is-open");
            TweenMax.set(this.$container,{
                y : 110 + "%"
            })
            TweenMax.set(this.$container.querySelectorAll(".js__gnavi-show"),{
                y : 30,
                opacity:0
            });
        }

    }
    spBtnMot(){
        if(this.status.mode=="close"){
            TweenMax.to(this.$trigger.querySelectorAll("rect")[0],0.4,{
                rotation : 0
            },0.1);
            TweenMax.to(this.$trigger.querySelectorAll("rect")[2],0.4,{
                rotation : 0
            },0.1);
            TweenMax.to(this.$trigger.querySelectorAll("rect")[1],0.4,{
                x : 0+"%",
                onComplete: () => {
                    this.$trigger.classList.remove("is-close");
                }
            },0.1);
        }

        TweenMax.staggerTo(this.$trigger.querySelectorAll("rect"),0.4,{
            x : 110 + "%",
            delay : this.status.mode=="close" ? 0.4 : 0
        },0.1,()=>{


            TweenMax.staggerTo(this.$trigger.querySelectorAll("rect"),0.4,{
                x : 0 + "%",
                delay : this.status.mode=="close" ? 0.2 : 0,
                onComplete:()=>{
                    if(this.status.mode=="open"){
                        this.$trigger.classList.add("is-close");
                        TweenMax.to(this.$trigger.querySelectorAll("rect")[0],0.4,{
                            rotation : 45
                        },0.1);
                        TweenMax.to(this.$trigger.querySelectorAll("rect")[2],0.4,{
                            rotation : -45
                        },0.1);
                        TweenMax.to(this.$trigger.querySelectorAll("rect")[1],0.4,{
                            x : -110+"%"
                        },0.1);
                    }
                }
            },0.1);
        });
    }
    // PC用のマウスオンアクション
    linkMot($t,type){

        if(!$t) return;

        if(type=="show"){
            TweenMax.to([$t.querySelectorAll(".jp"),$t.querySelectorAll(".en")],0.6,{
                color : "#907910",
            });
            TweenMax.to($t.parentNode.querySelectorAll(".current-icon"),0.6,{
                opacity : 1,
                scale : 1,
            });
        }else{
            if(this.$container.classList.contains('is-white')){
                TweenMax.to([$t.querySelectorAll(".jp"),$t.querySelectorAll(".en")],0.6,{
                    color : "#fff",
                });
            }else{
                TweenMax.to([$t.querySelectorAll(".jp"),$t.querySelectorAll(".en")],0.6,{
                    color : "#6b685e",
                });
            }
            TweenMax.to($t.parentNode.querySelectorAll(".current-icon"),0.6,{
                opacity : 0,
                scale : 0,
            });

        }

    }
    subOpen(_index,_type){

        let $target = this.$subContent[_index];

        if(this.$subTrigger[_index].classList.contains('is-open') || _type === 'hide'){ //hide
            this.status.hoverTime = setTimeout(() => {
                this.$subTrigger[_index].classList.remove('is-open');
                TweenMax.to($target, 0.3, {
                    opacity: 0,
                    display: 'none',
                });
            },2e2);
        }else{ //show
            this.$subTrigger[_index].classList.add('is-open');
            clearTimeout(this.status.hoverTime);
            TweenMax.to($target,0.3,{
                opacity : 1,
                display: 'block',
            });
        }

    }
    resize(w,h,displayType){

        if(this.status.displayType != displayType){
            this.status.displayType = displayType;
            if(displayType=="sp"){
                this.spMot("set");
            }else{
                this.spMot("reset");
            }
        }

    }
    enter(){
    }
    leave(){

    }
}
